export default __webpack_public_path__ + "static/media/2 - Указатели направления движения поездов.d0a3f33c.jpg";